import React, { useState, useEffect } from 'react';
import { mode } from '@chakra-ui/theme-tools';
import {
  Center,
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Button,
  Input,
  Select,
  useToast,
  Stack,
  Box,
  Spinner,
  FormControl,
  FormLabel,
  Switch,
} from '@chakra-ui/react';
import Card from 'components/card/Card';
import PermissionGroupApi from 'api/permissiongroup';
import { useSelectedPermissions } from 'contexts/PermissionGroupArrayContext';

const SelectedPermissionsTable = ({ AddToArray }, ...props) => {
  const { selectedPermissions } = useSelectedPermissions();
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [listTotal, setListTotal] = useState(2);
  const [searchTerm, setSearchTerm] = useState('');
  const [isError, setIsError] = useState('');

  const textColor = useColorModeValue('gray.700', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');

  useEffect(() => {
    console.log(selectedPermissions);
  }, [selectedPermissions]);

  const onPageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  let totalPages = Math.ceil(listTotal / itemsPerPage);
  const pageItems = [];
  for (let i = 1; i <= totalPages; i++) {
    pageItems.push(
      <Button
        key={i}
        size='sm'
        variant='ghost'
        color={i === currentPage ? 'brand.500' : 'gray.300'}
        onClick={() => onPageChange(i)}>
        {i}
      </Button>
    );
  }

  return (
    <Flex
      height='100%'
      direction='column'>
      <Card
        mt='4rem'
        direction='column'
        bgColor='gray.200'
        w='100%'
        h='42rem'
        px='0px'
        // mt={{ base: '180px', md: '120px' }}
        overflowX='hidden'>
        <Flex overflow='visible'>
          {loading ? (
            <Center
              mt={20}
              width='100%'
              // bgColor='red'
            >
              <Spinner size='xl' />
            </Center>
          ) : (
            <Table
              variant='simple'
              color='gray.500'
              mb='24px'>
              <Thead>
                <Tr>
                  <Th
                    pe='10px'
                    borderColor={borderColor}>
                    <Flex
                      justify='space-between'
                      align='center'
                      fontSize={{ sm: '10px', lg: '12px' }}
                      color='gray.500'>
                      Sr.no
                    </Flex>
                  </Th>
                  <Th
                    pe='10px'
                    borderColor={borderColor}>
                    <Flex
                      justify='space-between'
                      align='center'
                      fontSize={{ sm: '10px', lg: '12px' }}
                      color='gray.500'>
                      Name
                    </Flex>
                  </Th>
                  <Th
                    pe='10px'
                    borderColor={borderColor}>
                    <Flex
                      justify='space-between'
                      align='center'
                      fontSize={{ sm: '10px', lg: '12px' }}
                      color='gray.500'>
                      Module Name
                    </Flex>
                  </Th>
                </Tr>
              </Thead>

              <Tbody>
                {selectedPermissions.length > 0 &&
                  selectedPermissions?.map((obj, index) => {
                    return (
                      // <Link to={{ pathname: '/permission-group', state: obj.id }}>
                      <Tr key={obj.id}>
                        <Td>
                          <Flex align='center'>
                            <Text
                              me='10px'
                              color={textColor}
                              fontSize='sm'
                              fontWeight='700'>
                              {(currentPage - 1) * 10 + (index + 1)}
                            </Text>
                          </Flex>
                        </Td>
                        <Td>
                          <Flex align='center'>
                            <Text
                              me='10px'
                              color={textColor}
                              fontSize='sm'
                              fontWeight='700'>
                              {obj.name}
                            </Text>
                          </Flex>
                        </Td>
                        <Td>
                          <Flex align='center'>
                            <Text
                              me='10px'
                              color={textColor}
                              fontSize='sm'
                              fontWeight='700'>
                              {obj.module_name}
                            </Text>
                          </Flex>
                        </Td>
                      </Tr>
                      // </Link>
                    );
                  })}
              </Tbody>
            </Table>
          )}
        </Flex>

        {isError !== '' && <h2>{isError}</h2>}
      </Card>
    </Flex>
  );
};

export default SelectedPermissionsTable;
